export default {
  ORDER_PROMISE: 'ORDER_PROMISE',
  ORDER_LINKS: 'ORDER_LINKS',
  ORDER_PROCESS_URL: 'ORDER_PROCESS_URL',
  ORDER_PROCESS_PARAMS: 'ORDER_PROCESS_PARAMS',
  ORDER_PROCESS_METHOD: 'ORDER_PROCESS_METHOD',
}
